import EmbedOverlay from './embedOverlay.ui';

export default EmbedOverlay;
